class Feature
	constructor: () ->
		

module.exports=Feature
